const StringUtils = {
    FirstLetterUpperCase: (input) => {
        const inputArr = input.split(' ')
        return inputArr.map((item)=> `${item.charAt(0).toUpperCase()}${item.slice(1)} `) 
    }
}

export default StringUtils